import { render, staticRenderFns } from "./notification-types-grid.vue?vue&type=template&id=54ff088d&scoped=true&"
import script from "./notification-types-grid.ts?vue&type=script&lang=ts&"
export * from "./notification-types-grid.ts?vue&type=script&lang=ts&"
import style0 from "./notification-types-grid.scss?vue&type=style&index=0&id=54ff088d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff088d",
  null
  
)

export default component.exports